module.exports = __webpack_public_path__ + "01_face.7fb0449a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer1/01_face.png
// module id = jQlY
// module chunks = 0